// src/app/shared/formly-primeng/index.ts
import { ConfigOption } from '@ngx-formly/core';
import { withFormlyInput, withFormlyTextArea, withFormlySelect, withFormlyRadio, withFormlyCheckbox, withFormlyDatePicker, withFormlyFormField } from './public_api';

export function withFormlyPrimeNG(): ConfigOption {
  return {
    types: [
      ...withFormlyInput().types || [],
      ...withFormlyTextArea().types || [],
      ...withFormlySelect().types || [],
      ...withFormlyRadio().types || [],
      ...withFormlyCheckbox().types || [],
      ...withFormlyDatePicker().types || [],
    ],
    wrappers: [
      ...withFormlyFormField().wrappers || [],
    ]
  };
}